import { SourcesSidePanelBody } from "#features/conversations/components/sources-side-panel/SourcesSidePanelBody.tsx";
import { SourcesSidePanelHeader } from "#features/conversations/components/sources-side-panel/SourcesSidePanelHeader.tsx";
import { Grid, type GridProps } from "@hopper-ui/components";
import { useSourcesSidePanelStore } from "@workleap-ai/shared";

export const SourcesSidePanel = ({ ...rest }: Partial<GridProps>) => {
    const { activeMessage, activeCitations } = useSourcesSidePanelStore(state => state);

    if (!activeMessage) {
        return null;
    }

    return (
        <Grid
            templateRows={["auto", "1fr"]}
            height="100%"
            {...rest}
        >
            <SourcesSidePanelHeader count={activeCitations.length} />
            <SourcesSidePanelBody citations={activeCitations} />
        </Grid>
    );
};
